<template>
    <div class="Selection">

        <strong class="Selection-title">
            <hempel-icon name="featureBullet"/>
            {{ translation.calculate.result.selection.title }}
        </strong>

        <ul>
            <li
                v-for="(item, index) in selection"
                :key="index"
                class="Selection-item">
                <span class="Selection-itemLabel">{{ item.label }}</span>
                <hempel-button
                    :label="item.value"
                    tertiary-blue
                    @click="onClick(item.action, $event)"
                />
            </li>
        </ul>

    </div>
</template>
<script>
import HempelIcon from '@/components/shared/icon/Icon'
import HempelButton from '@/components/shared/button/Button'

export default {
    props: {
        selection: {
            type: Array,
            default() {
                return []
            }
        }
    },
    methods: {
        onClick(action, e) {
            if (action && typeof action === 'function') {
                action(e)
            }
        }
    },
    components: {
        HempelIcon,
        HempelButton
    }
}
</script>
